import {
    Geometry,
    Vector3,
} from 'three';

class ThreeDrawContext {
    constructor() {
        this.createGeometry = this.createGeometry.bind(this);

        this.geometriesVertices = [];
        this.currentGeometryVertices = null;
    }

    reset() {
        this.geometriesVertices = [];
        this.currentGeometryVertices = null;
    }

    moveTo(x, y) {
        if (this.currentGeometryVertices !== null) {
            this.geometriesVertices.push(this.currentGeometryVertices);
            this.currentGeometryVertices = null;
        }
        this.currentGeometryVertices = [];
        this.currentGeometryVertices.push([x, y]);
    }

    lineTo(x, y) {
        this.currentGeometryVertices.push([x, y]);
    }

    // eslint-disable-next-line
    beginPath() {}

    // eslint-disable-next-line
    arc(x, y, radius, startAngle, endAngle) {}

    // eslint-disable-next-line
    closePath() {}

    // eslint-disable-next-line class-methods-use-this
    createGeometry(points) {
        const geometry = new Geometry();
        points.forEach((point) => {
            geometry.vertices.push(new Vector3(point[0], point[1], 0));
        });
        return geometry;
    }

    getGeometries() {
        if (this.currentGeometryVertices !== null) {
            this.geometriesVertices.push(this.currentGeometryVertices);
            this.currentGeometryVertices = null;
        }
        return this.geometriesVertices.map(this.createGeometry);
    }
}

export default ThreeDrawContext;



// WEBPACK FOOTER //
// ./lib/ThreeDrawContext.js